// Articulation Trainer — tunable config.
// Change these without touching app logic.

export const REPS_PER_SESSION = 4;

// Conciseness budget per rep. Soft: we warn, we don't block.
export const BUDGET = { words: 60, sentences: 3 };

// Model used by the Cloudflare Pages Functions (server side).
export const MODEL = "claude-sonnet-5";

// The three response shapes we rotate through so you don't drill one script.
// Point-first is the constant; only the tail varies.
export const SHAPES = [
  {
    id: "per",
    label: "Point → reason → example",
    hint: "Lead with your point in the first sentence. Then one reason. Then one concrete example. Stop.",
  },
  {
    id: "rec",
    label: "Recommendation → tradeoff",
    hint: "State what you'd do in the first sentence. Then name the one real tradeoff. Stop.",
  },
  {
    id: "ans",
    label: "Answer → next step",
    hint: "Answer the question directly in the first sentence. Then the single next step. Stop.",
  },
];

// Filler words/phrases the local scorer counts. Dictation captures these when
// you say them aloud — which is the whole reason this mode is dictation-only.
export const FILLER_WORDS = [
  "um", "uh", "er", "ah", "hmm",
  "like", "you know", "i mean", "sort of", "kind of", "kinda",
  "basically", "actually", "literally", "honestly", "obviously",
  "just", "really", "very", "so yeah", "right?", "you see",
  "to be honest", "at the end of the day", "if that makes sense",
];

// Preamble openers that push your point out of the first sentence.
export const HEDGE_OPENERS = [
  "well", "so", "um", "uh", "i think", "i guess", "i feel like",
  "i mean", "basically", "honestly", "to be honest", "in my opinion",
  "kind of", "sort of", "you know", "i would say", "i'd say",
  "the thing is", "let me", "okay so", "yeah so", "i just think",
];
